<script setup>
    import { ref, onMounted, watch  } from 'vue';
    import axios from 'axios';
    import VueDatePicker from '@vuepic/vue-datepicker';
    import { isValidIBAN } from 'ibantools';
    import Swal from 'sweetalert2';



    const submitResult = ref(null);
    const submitError = ref(null);
    const props = defineProps(['rechnungsempfaenger', 'teilnehmer','tarifnummer',
     'vertragsbeginn','vertragsende','vorname', 'name', 'firmennachzahler',
     'kartennummer', 'bemerkung', 'tarifbezeichnung', 'stammanlagennummer',
    'stammanlagenbezeichnung', 'wochenprogrammgueltigkeit', 'wochenprogrammnummer',
    'monatspauschale', 'nachzahltarif', 'ueberziehungsgebuehr',
    'rabattteilnehmer', 'gutschrift', 'bestpreismin',
    'bestpreismax', 'status', 'mindate', 'maxdate'
    , 'anrede','name1', 'name2', 'strasse', 'ort', 'plz', 'land', 'email', 'telefon1',   // Firmennachzahler daten
      'iban', 'zahlart', 'geburtsdatum', // Firmennachzahler daten
       'nutzergruppen', 'show_nutzergruppe', 'nutzergruppe', 'danger']);


    const danger = ref(props.danger);

    const show_nutzergruppe = ref(props.show_nutzergruppe);
    const nutzergruppenArray = ref([]);
    onMounted(() => {
        nutzergruppenArray.value = JSON.parse(props.nutzergruppen);



    });




    const isModalVisible = ref(false);
    const isLoading = ref(null);

    // Datepicker for start and end should be between the start and end of the contract
    const minDate = ref(formatDateJS(props.mindate));
    const maxDate = ref(formatDateJS(props.maxdate));

    // Data that is beeing prepared to be send
    const newTeilnehmerData = ref({
        Rechnungsempfaenger: props.rechnungsempfaenger,
        Teilnehmer: props.teilnehmer,
        Tarifnummer: props.tarifnummer,
        Vertragsbeginn :formatDateJS(props.vertragsbeginn),
        Vertragsende:formatDateJS(props.vertragsende),
        Vorname: props.vorname,
        Name: props.name,
        Firmennachzahler: props.firmennachzahler,
        Kartennummer: props.kartennummer,
        Bemerkung: props.bemerkung,
        Tarifbezeichnung: props.tarifbezeichnung,
        Stammanlagennummer: props.stammanlagennummer,
        Stammanlagenbezeichnung: props.stammanlagenbezeichnung,
        Wochenprogrammgueltigkeit: props.wochenprogrammgueltigkeit,
        Wochenprogrammnummer: props.wochenprogrammnummer,
        Monatspauschale: props.monatspauschale,
        Nachzahltarif: props.nachzahltarif,
        Ueberziehungsgebuehr: props.ueberziehungsgebuehr,
        RabattTeilnehmer: props.rabattteilnehmer,
        Gutschrift: props.gutschrift,
        Bestpreismin: props.bestpreismin,
        Bestpreismax: props.bestpreismax,
        Status: (props.status == "") ? '0' : props.status,
        Anrede:props.anrede,Name1:props.name1, Name2:props.name2, Strasse:props.strasse, Ort:props.ort,// Firmennachzahler
        Plz:props.plz, Land:props.land, Email:props.email, Telefon1:props.telefon1,
        Iban:props.iban, Zahlart:props.zahlart, Geburtsdatum:formatDateJS(props.geburtsdatum),
        Nutzergruppe: (show_nutzergruppe.value ? ((props.nutzergruppe == "") ? '1001' : props.nutzergruppe) : ""),
        archiveChange: true

    });


    const getShowNutzerGruppe = (tarifnummer) => {
        axios.get('/nutzergruppen/' + tarifnummer )
            .then(response => {
                if(response.data){
                    show_nutzergruppe.value = true;
                    newTeilnehmerData.value.Nutzergruppe = "1001";
                } else{
                    show_nutzergruppe.value = false;
                    newTeilnehmerData.value.Nutzergruppe = "";
                }
            })
            .catch(error => {
                 console.error(error);

            });
    };


    watch(() => newTeilnehmerData.value.Tarifnummer, (newVal) => {
        // check if the tarif to nutzergruppe relation exists. If not show the selection box for the user
        if (newVal.length > 0) {
            getShowNutzerGruppe(newVal);
        }
    });

    function formatDateJS( date){
       if( typeof(date) == "string" && date.length == 10 ){
            return date.substring(0,4)  + date.substring(4,7) +  date.substring(7) + "T00:00:00.000Z";

        } else
        if( typeof(date) != "string" || date.length != 8 ){
            return setStartDate()
        }
        return date.substring(0,4) + "-" + date.substring(4,6) + "-" + date.substring(6) + "T00:00:00.000Z";
    }

    function setStartDate(){
        const now = new Date();
        const day = now.getDate() < 10 ? "0"+now.getDate() : now.getDate();
        const month = now.getMonth()+1 < 10 ? "0"+(now.getMonth()+1) : now.getMonth()+1;
        const startDate = now.getFullYear() + '-' + month + '-' + day + "T00:00:00.000Z";
        return startDate;
    }

    const errorBanking = ref("");


    // when changing the invoice type, values should be reset
    function resetValues(){
        if(oldRechArt != newTeilnehmerData.value.RabattTeilnehmer){
            newTeilnehmerData.value.Bestpreismax = "";
            newTeilnehmerData.value.Bestpreismin = "";
            newTeilnehmerData.value.Gutschrift = "";
            oldRechArt = newTeilnehmerData.value.RabattTeilnehmer;
        }

    }

    var oldRechArt =  newTeilnehmerData.value.RabattTeilnehmer;




    // format the price data from the javascript before sending
    function formatPrice(){
        newTeilnehmerData.value.Bestpreismax = parseFloat((newTeilnehmerData.value.Bestpreismax).replaceAll(",", ".")).toString();
        newTeilnehmerData.value.Bestpreismin = parseFloat((newTeilnehmerData.value.Bestpreismin).replaceAll(",", ".")).toString();
        newTeilnehmerData.value.Gutschrift = parseFloat((newTeilnehmerData.value.Gutschrift).replaceAll(",", ".")).toString();
        if( newTeilnehmerData.value.Bestpreismax == "NaN"){
            newTeilnehmerData.value.Bestpreismax = "0"
        }
        if( newTeilnehmerData.value.Bestpreismin == "NaN"){
            newTeilnehmerData.value.Bestpreismin = "0"
        }
        if( newTeilnehmerData.value.Gutschrift == "NaN"){
            newTeilnehmerData.value.Gutschrift = "0"
        }
    }

    // function is called when the price input fields change.
    function changePoint(){
        newTeilnehmerData.value.Bestpreismin =  newTeilnehmerData.value.Bestpreismin.replaceAll('.', ',')
        newTeilnehmerData.value.Bestpreismax = newTeilnehmerData.value.Bestpreismax.replaceAll('.', ',')
        newTeilnehmerData.value.Gutschrift = newTeilnehmerData.value.Gutschrift.replaceAll('.', ',')
    }

    // helper function to stop error message
    function timeout(i){
        if(i == 1){
            document.getElementById("iban").classList.remove("is-invalid") ;
        }
        errorBanking.value = "";

    }


    async function submit() {
        isLoading.value = true;

        // If Tarifnummer is 84, ask for forced cancellation confirmation
        if (newTeilnehmerData.value.Tarifnummer == 84 && newTeilnehmerData.value.archiveChange)  {
            const result = await Swal.fire({
                title: "Zwangskündigung?",
                text: "Soll diese Kündigung als Zwangskündigung durchgeführt werden?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ja",
                cancelButtonText: "Nein"
            });
            // Set forced to true if confirmed, false otherwise.
            newTeilnehmerData.value.forced = result.isConfirmed;
        } else {
            // For any other tariff, forced is false
            newTeilnehmerData.value.forced = false;
        }

        // Continue with further validations (like IBAN, price formatting, etc.)
        if ( newTeilnehmerData.value.Firmennachzahler.length > 0 && newTeilnehmerData.value.Zahlart == "SEPA-Basislastschrift (CORE)"){
            if(!isValidIBAN( newTeilnehmerData.value.Iban)){
                document.getElementById("iban").classList.add("is-invalid");
                errorBanking.value += "iban";
                setTimeout(timeout, 2000, 1);
                isLoading.value = false;
                return;

            }

        }


        formatPrice();
        submitError.value = null;
        submitResult.value = null;

        newTeilnehmerData.value.Name1 = newTeilnehmerData.value.Name;
        newTeilnehmerData.value.Name2 = newTeilnehmerData.value.Vorname;


        await axios.put("teilnehmeredit/" + props.rechnungsempfaenger +  "/" + props.teilnehmer, newTeilnehmerData.value, { timeout: 6000 })
        .then(function (response) {
            submitResult.value = response;

            if(props.teilnehmer != newTeilnehmerData.value.Teilnehmer){
             window.location = "/teilnehmerliste";
            }

            if(response !=null &&  response.data.status_code == 200){
                newTeilnehmerData.value.Monatspauschale = response.data.data.Monatspauschale;
                newTeilnehmerData.value.Tarifbezeichnung = response.data.data.Tarifbezeichnung;
                if (response.data.data.Text != null && response.data.data.Text.length > 0){
                    Swal.fire({
                            title: "Achtung",
                            text: response.data.data.Text,
                            icon: "warning",
                            timer: 2000,
                        },)
                }

            }

            isLoading.value = false;

            setTimeout(function(){submitError.value=null; submitResult.value=null; timeOutError.value = null}, 3000);


        }).catch(function (error) {
            if(error.code === 'ECONNABORTED'){
                timeOutError.value = "Server konnte nicht erreicht werden! Überprüfen Sie Ihre Verbindung.";
            } else {
                submitError.value = error;
            }
            isLoading.value = false;
            setTimeout(function(){submitError.value=null; submitResult.value=null; timeOutError.value = null}, 3000);


        });

    }

    const timeOutError = ref(null);


    // get data form child component (TarifSelect)
    const handleData = (data) => {
        newTeilnehmerData.value.Tarifnummer =  data ;
        $('.modal').modal('hide');

    };

    async function clearFirmennachzahlerField(){
        Swal.fire({
            title: "Sind Sie sicher?",
            text: "Sind Sie sicher, dass Sie das Firmennahzahlerfeld leeren wollen?",
            icon: "warning",
            confirmButtonText: "Leeren",
            confirmButtonColor: "#e64942",
            showCancelButton: true,
            cancelButtonText: "Abbrechen",
            focusCancel: true,
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await axios.delete("/firmennachzahler/clear/" + newTeilnehmerData.value.Rechnungsempfaenger
                + "/" + newTeilnehmerData.value.Teilnehmer)
                .then((data) => {
                    if (data.status === 200) {
                        Swal.fire({
                            title: "Erfolgreich",
                            text: "Firmennachzahler wurde geleert!",
                            icon: "success",
                        })
                        newTeilnehmerData.value.Firmennachzahler = "";
                        danger.value = "";
                    }

                })
            }
        }).catch((error) => {
            Swal.fire({
                title: "Fehlgeschlagen",
                text: error.response.data.message,
                icon: 'error',
            });
        })
    }

    async function deleteFirmennachzahler(){
        Swal.fire({
            title: "Sind Sie sicher?",
            text: "Sind Sie sicher, dass Sie den Firmennahzahler löschen wollen?",
            icon: "warning",
            confirmButtonText: "Löschen",
            confirmButtonColor: "#e64942",
            showCancelButton: true,
            cancelButtonText: "Abbrechen",
            focusCancel: true,
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await axios.delete("/firmennachzahler/remove/" + newTeilnehmerData.value.Rechnungsempfaenger
                    + "/" + newTeilnehmerData.value.Teilnehmer)
                .then((data) => {
                    if (data.status === 200) {
                        Swal.fire({
                            title: "Erfolgreich",
                            text: "Firmennachzahler wurde gelöscht!",
                            icon: "success",
                        })
                        newTeilnehmerData.value.Firmennachzahler = "";
                    }

                })
            }
        }).catch((error) => {
            Swal.fire({
                title: "Fehlgeschlagen",
                text: error.response.data.message,
                icon: 'error',
            });
        })
    }

</script>


<template>

     <div class="grid-container">
        <div class="col">
            <form @submit.prevent="submit" class="teilnehmerEditForm">
                <div style="display: flex; flex-wrap: wrap; justify-content: space-evenly;">
                    <div class="form-group row">
                        <label for="rechnungsempfaenger_" style="padding: 0%;">Rechnungsempfänger*</label>
                        <input id="rechnungsempfaenger_" readonly type="text" class="form-control"
                        v-model="newTeilnehmerData.Rechnungsempfaenger"
                        >  </input>
                    </div>
                    <div class="form-group row">
                        <label for="teilnehmer_" style="padding: 0%;">Teilnehmer*</label>
                        <input id="teilnehmer_" readonly type="text" class="form-control"
                        v-model="newTeilnehmerData.Teilnehmer"
                        >  </input>
                  </div>

                    <div class="form-group row">
                        <label for="tarifnummer" style="padding: 0%;">Tarifnummer*</label>
                        <input
                            v-model="newTeilnehmerData.Tarifnummer"
                            type="text"
                            id="tarifnummer"
                            name="tarifnummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Tarifnummer !== 'undefined'),
                            }"
                        />
                        <div>
                            <span
                                data-bs-toggle="modal"
                                data-bs-target=".modal"
                                @click="isModalVisible=true"
                                style="margin-top:-30px;cursor:pointer; text-align:right;float:right; width:30%">
                                    <i class="fas fa-edit" style="color: #a6a6a6;"></i>
                            </span>
                        </div>

                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Tarifnummer !== 'undefined')">
                            {{ submitError.response.data.Tarifnummer[0] }}
                        </div>
                    </div>
                    <div class="form-group row" style=" margin-left: 0.0em">
                        <label for="tarifbezeichnung" style="padding: 0%;">Tarifbezeichnung</label>
                        <input id="tarifbezeichnung" readonly type="text" class="form-control"
                        v-model="newTeilnehmerData.Tarifbezeichnung"
                        >  </input>
                    </div>
                    <div class="form-group" style="margin-left: 0.0em">
                        <label>Vertragsbeginn*</label>
                        <VueDatePicker
                            v-model="newTeilnehmerData.Vertragsbeginn"
                            text-input
                            format="dd.MM.yyyy"
                            locale="de"
                            :enable-time-picker="false"
                            selectText="Auswählen"
                            cancelText="Abbrechen"
                            id="vertragsbeginn"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined'),
                            }"
                            utc
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined')">
                            {{ submitError.response.data.Vertragsbeginn[0] }}
                        </div>
                    </div>
                    <div class="form-group" style="margin-left: -0.4em">
                        <label>Vertragsende*</label>
                        <VueDatePicker
                            v-model="newTeilnehmerData.Vertragsende"
                            text-input
                            format="dd.MM.yyyy"
                            locale="de"
                            :enable-time-picker="false"
                            selectText="Auswählen"
                            cancelText="Abbrechen"
                            id="vertragsende"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Vertragsende !== 'undefined'),
                            }"
                            utc
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vertragsende !== 'undefined')">
                            {{ submitError.response.data.Vertragsende[0] }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="vorname" style="padding: 0%;">Vorname</label>
                        <input
                            v-model="newTeilnehmerData.Vorname"
                            type="text"
                            id="vorname"
                            name="vorname"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Vorname !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vorname !== 'undefined')">
                            {{ submitError.response.data.Vorname[0] }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="name" style="padding: 0%;">Name</label>
                        <input
                            v-model="newTeilnehmerData.Name"
                            type="text"
                            id="name"
                            name="name"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Name !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name !== 'undefined')">
                            {{ submitError.response.data.Name[0] }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="kartennummer" style="padding: 0%;">Kartennummer</label>
                        <input
                            v-model="newTeilnehmerData.Kartennummer"
                            type="text"
                            id="kartennummer"
                            name="kartennummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Kartennummer !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Kartennummer !== 'undefined')">
                            {{ submitError.response.data.Kartennummer[0] }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="bemerkung" style="padding: 0%;">Bemerkung</label>
                        <input
                            v-model="newTeilnehmerData.Bemerkung"
                            type="text"
                            id="bemerkung"
                            name="bemerkung"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Bemerkung !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bemerkung !== 'undefined')">
                            {{ submitError.response.data.Bemerkung[0] }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="stammanlagennummer" style="padding: 0%;">Stammanlagennummer</label>
                        <input
                            v-model="newTeilnehmerData.Stammanlagennummer"
                            type="text"
                            id="stammanlagennummer"
                            name="stammanlagennummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Stammanlagennummer !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Stammanlagennummer !== 'undefined')">
                            {{ submitError.response.data.Stammanlagennummer[0] }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="stammanlagenbezeichnung" style="padding: 0%;">Stammanlagenbezeichnung</label>
                        <input
                            v-model="newTeilnehmerData.Stammanlagenbezeichnung"
                            type="text"
                            id="stammanlagenbezeichnung"
                            name="stammanlagenbezeichnung"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Stammanlagenbezeichnung !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Stammanlagenbezeichnung !== 'undefined')">
                            {{ submitError.response.data.Stammanlagenbezeichnung[0] }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="Wochengueltigkeit" style="padding: 0%;">Wochenprogrammgültigkeit</label>
                        <input
                            v-model="newTeilnehmerData.Wochenprogrammgueltigkeit"
                            type="text"
                            id="Wochengueltigkeit"
                            name="Wochengueltigkeit"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Wochenprogrammgueltigkeit !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Wochenprogrammgueltigkeit !== 'undefined')">
                            {{ submitError.response.data.Wochenprogrammgueltigkeit[0] }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="wochenprogrammnummer" style="padding: 0%;">Wochenprogrammnummer</label>
                        <input
                            v-model="newTeilnehmerData.Wochenprogrammnummer"
                            type="text"
                            id="wochenprogrammnummer"
                            name="wochenprogrammnummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Wochenprogrammnummer !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Wochenprogrammnummer !== 'undefined')">
                            {{ submitError.response.data.Wochenprogrammnummer[0] }}
                        </div>
                    </div>
                    <div class="form-group row" >
                        <label for="monatspauschale" style="padding: 0%;">Monatspauschale</label>
                        <input id="monatspauschale" readonly type="text" class="form-control"
                        v-model="newTeilnehmerData.Monatspauschale"
                        >  </input>
                    </div>
                    <div class="form-group row">
                        <label for="nachzahltarif" style="padding: 0%;">Nachzahltarif</label>
                        <input
                            v-model="newTeilnehmerData.Nachzahltarif"
                            type="text"
                            id="nachzahltarif"
                            name="nachzahltarif"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Nachzahltarif !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Nachzahltarif !== 'undefined')">
                            {{ submitError.response.data.Nachzahltarif[0] }}
                        </div>
                    </div>
                    <div class="form-group row" >
                        <label for="ueberziehungsgebuehr" style="padding: 0%;">Überziehungsgebühr</label>
                        <select v-model="newTeilnehmerData.Ueberziehungsgebuehr" class="form-select" name="ueberziehungsgebuehr" id="ueberziehungsgebuehr">
                            <option value="0">Überziehung bar</option>
                            <option value="1">Überziehung in Rechnung stellen</option>
                            <option value="2">Autorisieren</option>
                        </select>
                    </div>
                    <div class="form-group row" v-if="show_nutzergruppe" >
                        <label for="status" style="padding: 0%;">Nutzergruppe</label>
                        <select value="1001" v-model="newTeilnehmerData.Nutzergruppe" class="form-select" name="nutzergruppe" id="Nutzergruppe">
                            <option v-for="nutzergruppe in nutzergruppenArray" :key="nutzergruppe.nutzergruppe" :value="nutzergruppe.nutzergruppe">
                                {{ nutzergruppe.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group row" >
                        <label for="status" style="padding: 0%;">Status</label>
                        <select value="0" v-model="newTeilnehmerData.Status" class="form-select" name="status" id="status">
                            <option value="0">Aktiv</option>
                            <option value="2">Nicht aktiv</option>
                        </select>
                    </div>

                    <div class="form-group row" >
                        <label for="rabattteilnehmer" style="padding: 0%;">Abrechnungsart</label>
                        <select :onchange="resetValues()" v-model="newTeilnehmerData.RabattTeilnehmer" class="form-select" name="rabattteilnehmer" id="rabattteilnehmer">
                            <option value="0">Normal</option>
                            <option value="1">Bestabrechnung</option>
                            <option value="2">Vielparker</option>
                        </select>
                    </div>
                    <div v-if=" newTeilnehmerData.RabattTeilnehmer == 2" class="form-group row">
                        <label for="gutschrift" style="padding: 0%;">Gutschrift</label>
                        <input
                            v-model="newTeilnehmerData.Gutschrift"
                            type="text"
                            id="gutschrift"
                            name="gutschrift"
                            :onchange="changePoint()"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Gutschrift !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Gutschrift !== 'undefined')">
                            {{ submitError.response.data.Gutschrift[0] }}
                        </div>
                    </div>
                    <div v-if=" newTeilnehmerData.RabattTeilnehmer == 1" class="form-group row">
                        <label for="bestpreismin" style="padding: 0%;">Bestpreismin</label>
                        <input
                            v-model="newTeilnehmerData.Bestpreismin"
                            type="text"
                            id="bestpreismin"
                            name="bestpreismin"
                            :onchange="changePoint()"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Bestpreismin !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bestpreismin !== 'undefined')">
                            {{ submitError.response.data.Bestpreismin[0] }}
                        </div>
                    </div>
                    <div v-if=" newTeilnehmerData.RabattTeilnehmer == 1" class="form-group row">
                        <label for="bestpreismax" style="padding: 0%;">Bestpreismax</label>
                        <input
                            v-model="newTeilnehmerData.Bestpreismax"
                            type="text"
                            id="bestpreismax"
                            name="bestpreismax"
                            :onchange="changePoint()"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Bestpreismax !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bestpreismax !== 'undefined')">
                            {{ submitError.response.data.Bestpreismax[0] }}
                        </div>
                    </div>

                    <!--If firmennachzahler is filled it should be in a new row -->
                    <div v-if="newTeilnehmerData.Firmennachzahler.length != 0 && (newTeilnehmerData.RabattTeilnehmer != 1 && !(show_nutzergruppe &&  newTeilnehmerData.RabattTeilnehmer == 2) || (show_nutzergruppe &&  newTeilnehmerData.RabattTeilnehmer == 1) )   " class="form-group row"></div>
                    <div v-if="newTeilnehmerData.Firmennachzahler.length != 0 && ((newTeilnehmerData.RabattTeilnehmer == 0 && !show_nutzergruppe) || (show_nutzergruppe &&  newTeilnehmerData.RabattTeilnehmer == 1)  )" class="form-group row"></div>



                    <div class="form-group row">
                        <label for="firmennachzahler" style="padding: 0%;">Firmennachzahler</label>
                        <input
                            v-model="newTeilnehmerData.Firmennachzahler"
                            type="text"
                            id="firmennachzahler"
                            name="firmennachzaher"
                            readonly
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Firmennachzahler !== 'undefined'),
                            }"
                        />
                        <div>
                            <span v-if="newTeilnehmerData.Firmennachzahler.length == 0"
                                data-bs-toggle="modal"
                                data-bs-target="#createNachzahler"
                                @click="isModalVisible=true"
                                style="margin-top:-30px;cursor:pointer; text-align:right;float:right; width:30%">
                                    <i class="fas fa-plus" style="color: #a6a6a6;"></i>
                            </span>

                        </div>
                        <button v-if="newTeilnehmerData.Firmennachzahler.length != 0" @click="deleteFirmennachzahler()" id="loesche" type="button" class="btn btn-primary" style="left: 50%;"> Löschen </button>
                        <button v-if="danger" style="margin-top: 5px" type="button" class="btn btn-primary" @click="clearFirmennachzahlerField()">Firmennachzahlerfeld leeren</button>
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Firmennachzahler !== 'undefined')">
                            {{ submitError.response.data.Firmennachzahler[0] }}
                        </div>
                    </div>
                <div class="form-group row">

                </div>
                <div class="form-group row">
                </div>
                <div v-if="newTeilnehmerData.Firmennachzahler.length != 0"class="form-group row">
                    <h3 style="
                        margin-top: 20px;
                        margin-bottom: 10px;
                        margin-left: -10px;">
                         Daten Firmennachzahler

                    </h3>

                </div>

                <div class="form-group row">
                    <h4 v-if="danger" style="color:red">(ACHTUNG! Es exisitert ein Teilnehmer mit der selben Firmennachzahlernummer!!!!!)</h4>
                </div>
                <div class="form-group row">

                </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0" class="form-group row">
                <label style="padding: 0%;"  for="anrede">Anrede</label>
                <select id="anrede" v-model="newTeilnehmerData.Anrede" class="form-select form-control">
                    <option value="Herr">Herr</option>
                    <option value="Frau">Frau</option>
                    <option value="Divers">Divers</option>
                </select>
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Anrede !== 'undefined')" v-html="submitError.response.data.Anrede"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0" class="form-group row">
                <label style="padding: 0%;"  for="name2">Vorname*</label>
                <input id="name2"
                    type="text"
                    v-model="newTeilnehmerData.Name2"
                    readonly
                    :class="{
                        'form-control': true,
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Name2 !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name2 !== 'undefined')" v-html="submitError.response.data.Name2[0]"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0" class="form-group row">
                <label style="padding: 0%;"  for="name1">Name*</label>
                <input id="name1"
                    type="text"
                    v-model="newTeilnehmerData.Name1"
                    readonly
                    :class="{
                        'form-control': true,
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Name1 !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name1 !== 'undefined')" v-html="submitError.response.data.Name1[0]"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0"  class="form-group row">
                <label  style="padding: 0%;" for="strasse">Straße</label>
                <input id="strasse"
                    type="text"
                    v-model="newTeilnehmerData.Strasse"
                    :class="{
                        'form-control': true,
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Strasse !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Strasse !== 'undefined')" v-html="submitError.response.data.Strasse[0]"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0"  class="form-group row">
                <label  style="padding: 0%;" for="ort">Ort</label>
                <input id="ort"
                    type="text"
                    v-model="newTeilnehmerData.Ort"
                    :class="{
                        'form-control': true,
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Ort !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Ort !== 'undefined')" v-html="submitError.response.data.Ort[0]"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0"  class="form-group row">
                <label style="padding: 0%;"  for="plz">Postleitzahl</label>
                <input id="plz"
                    type="text"
                    v-model="newTeilnehmerData.Plz"
                    :class="{
                        'form-control': true,
                        'is-invalid': (submitError !== null && typeof submitError.response.data.PLZ !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.PLZ !== 'undefined')" v-html="submitError.response.data.PLZ[0]"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0"  class="form-group row">
                <label style="padding: 0%;" for="land">Land</label>
                <select id="land" v-model="newTeilnehmerData.Land" class="form-select form-control">
                    <option value="Deutschland">Deutschland</option>
                    <option value="Belgien">Belgien</option>
                    <option value="Niederlande">Niederlande</option>
                    <option value="Luxemburg">Luxemburg</option>
                    <option value="Frankreich">Frankreich</option>
                    <option value="Österreich">Österreich</option>
                    <option value="Schweiz">Schweiz</option>
                    <option value="Italien">Italien</option>
                    <option value="Rumänien">Rumänien</option>
                    <option value="Spanien">Spanien</option>
                </select>
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Land !== 'undefined')" v-html="submitError.response.Land"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0"  class="form-group row">
                <label  style="padding: 0%;" for="email">E-Mail</label>
                <input id="email"
                    type="text"
                    v-model="newTeilnehmerData.Email"
                    :class="{
                        'form-control': true,
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Email !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Email !== 'undefined')" v-html="submitError.response.data.Email[0]"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0"  class="form-group row">
                <label  style="padding: 0%;"  for="telefon1">Telefonnummer</label>
                <input id="telefon1"
                    type="text"
                    v-model="newTeilnehmerData.Telefon1"
                    :class="{
                        'form-control': true,
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Telefon1 !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Telefon1 !== 'undefined')" v-html="submitError.response.data.Telefon1[0]"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0"  class="form-group row">
                <label  style="padding: 0%;" for="zahlart">Zahlart</label>
                <select id="zahlart" v-model="newTeilnehmerData.Zahlart" class="form-select form-control">
                    <option value="Überweisung">Überweisung</option>
                    <option value="SEPA-Basislastschrift (CORE)">IBAN</option>
                </select>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0 && newTeilnehmerData.Zahlart === 'SEPA-Basislastschrift (CORE)'" class="form-group row">
                <label style="padding: 0%;"  for="iban">IBAN*</label>
                <input
                    id="iban"
                    type="text"
                    v-model="newTeilnehmerData.Iban"
                    data-maska="@@## **** **** **** **** **** **** **** **"
                    :class="{
                        'form-control': true,
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Iban !== 'undefined'),
                    }"
                />
                <div v-if="(errorBanking.includes('iban'))" class="invalid-feedback"> Die eingegebene Iban ist nicht korrekt. Bitte überprüfen!  </div>
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Iban !== 'undefined')" v-html="submitError.response.data.Iban[0]"></div>
            </div>

            <div v-if="newTeilnehmerData.Firmennachzahler.length != 0" class="form-group row">
                <label  style="padding: 0%;" for="geburtsdatum">Geburtsdatum</label>
                <VueDatePicker
                    v-model="newTeilnehmerData.Geburtsdatum"
                    id="geburtsdatum"
                    text-input
                    format="dd.MM.yyyy"
                    locale="de"
                    :enable-time-picker="false"
                    selectText="Auswählen"
                    cancelText="Abbrechen"
                    :class="{
                        'form-control': true,
                        'is-invalid': submitError !== null && typeof submitError.response.data.Geburtsdatum !== 'undefined'
                        }"
                    utc
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Geburtsdatum !== 'undefined')" v-html="submitError.response.data.Geburtsdatum[0]"></div>
            </div>
            </div>
                <br>

                <div style="margin:10px; padding-right: 13.5%;   display: flex;justify-content: center;"
                 v-if="newTeilnehmerData.Tarifnummer == 70 || newTeilnehmerData.Tarifnummer == 84">
                    <div style="display: flex;align-items: center;">
                            <div class="checkbox-container">
                                <input type="checkbox" id="archiveChange" v-model="newTeilnehmerData.archiveChange" />
                                <div class="check"></div>
                            </div>
                            <span>Änderung archivieren</span>
                    </div>
                </div>
                <div style="display: flex;justify-content: center;flex-direction: column;align-content: center;align-items: center;">
                    <div style="width: 30%;">
                        <div style=" display: flex;justify-content: space-around;">
                            <button id="submit"
                                type="button"
                                class="btn btn-primary"
                                @click="submit()"
                                style="left:50%"
                            >
                                Speichern
                                <i :class="[isLoading ? 'fa-solid fa-spinner fa-spin' : '']" :disabled="isLoading"></i>
                            </button>
                            <div>
                                <a :href="`/users/${newTeilnehmerData.Rechnungsempfaenger}`" class="btn btn-primary">zum Rechnungsempfänger</a>
                            </div>
                         </div>
                        <div v-if="(submitResult!=null) &&  (submitResult.data.status_code == 200)" style="margin-top: 5px;" class="alert alert-success">
                            Gespeichert!
                        </div>
                        <div v-else-if="(submitResult!=null)&&  (submitResult.data.status_code != 200)" class="alert alert-error">
                            Daten konnten nicht gespeichert werden!
                        </div>
                        <div v-else-if="(timeOutError!=null)" class="alert alert-error">
                            {{ timeOutError }}
                        </div>

                    </div>
                </div>

            </form>
        </div>
    </div>

    <div>



    </div>


    <div class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Tarif ändern</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div v-if="isModalVisible" class="modal-body">
                   <TarifSelect  @tarifValue="handleData" :value="newTeilnehmerData.Tarifnummer">

                   </TarifSelect>
                </div>
            </div>
        </div>
    </div>

</template>
